/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 2 hook(s) need dependency review; fix each and remove this directive */
import SlickGrid1 from "@CubeComponents/html/SlickGrid1";
import React, { forwardRef, useEffect, useMemo, useRef } from "react";
import IconComponent from "@CubeComponents/icons";
// import TextFieldComponent from "@CubeComponents/Mui_Form/TextFieldComponent";
import { Box, Menu, MenuItem } from "@mui/material";
import { portalCreateRoot as createRoot } from "@CubeComponents/html/cellPortals";
import { fileViewModes } from "./constants";
import { getIconbasedOnResourceType } from "@CubeComponents/constants/globalFunctions";
import CheckBoxComponent from "@CubeComponents/Mui_Form/CheckBox";
import Text from "@CubeComponents/html/Text/Text";
import useFileManagerFiles from "./useFileManagerFiles";
import TextFieldComponent from "@CubeComponents/Mui_Form/TextFieldComponent";

interface FilemanagerFileProps {
  setSelectedFolder: any;
  onFileClick: Function;
  onFileSelect: Function;
  fileManagerData: any;
  contextMenuSettings: any;
  menuOpen: any;
  fileColumns: any;
  tempFolder: any;
  handleSearchFiles: Function;
  onFileLoad: Function;
  beforeSending: Function;
  allowDragAndDropUpload: boolean;
  selectedFolder: any;
  filesViewMode: string;
  setSelectedFilesInIconsMode: any;
  selectedFilesInIconsMode: any;
  setIsViewRendered: any;
  isViewRendered: boolean;
  disableDragAndDropUpload: boolean;
  preSearchText?: string;
  // Project ("Folders") mode: host the grid's own toolbar in a shared slot above the tree + grid, and feed
  // it the file-manager toolbar items. When absent, the grid toolbar stays hidden (single-space/popup).
  toolbarContainer?: HTMLElement | null;
  commonToolbar?: any[];
  commonToolbarClickHandler?: (id: string) => void;
  // Project ("Folders") mode: the grid sits inside a shared bordered card, so drop its own outer border.
  disableOuterBorder?: boolean;
}

const Files = forwardRef(
  (
    {
      setSelectedFolder,
      onFileClick = () => {},
      onFileSelect = () => {},
      fileManagerData = {},
      contextMenuSettings,
      menuOpen,
      fileColumns,
      tempFolder,
      handleSearchFiles = () => {},
      onFileLoad = () => {},
      beforeSending,
      allowDragAndDropUpload,
      selectedFolder,
      filesViewMode = "DETAILED_FILES",
      setSelectedFilesInIconsMode,
      selectedFilesInIconsMode,
      setIsViewRendered,
      isViewRendered,
      disableDragAndDropUpload,
      preSearchText = "",
      toolbarContainer,
      commonToolbar = [],
      commonToolbarClickHandler,
      disableOuterBorder,
    }: FilemanagerFileProps,
    ref,
  ) => {
    const tempRef = useRef<any>({});
    const dataGrid: any = ref || tempRef;

    const {
      // State
      disabledRows,
      // breadCrumbData,
      filesData,
      columnDefinitions,
      menuState,
      query,
      isOver,

      // Refs

      // Handlers
      setSelectedRows,
      recordClick,
      selectionHandlerSlickGrid,
      searchFileHandler,
      handleClose,
      contextMenuForIconsView,
      handleGridCreated,
      onContextMenu,
      onDragEnter,
      onDragLeave,
      onDragOver,
      handleDrop,
      handleMenuClick,
      checkIconBoxSelect,

      // Translation
      t,
    } = useFileManagerFiles({
      setSelectedFolder,
      onFileClick,
      onFileSelect,
      fileManagerData,
      contextMenuSettings,
      menuOpen,
      fileColumns,
      tempFolder,
      handleSearchFiles,
      onFileLoad,
      beforeSending,
      allowDragAndDropUpload,
      selectedFolder,
      filesViewMode,
      setSelectedFilesInIconsMode,
      selectedFilesInIconsMode,
      setIsViewRendered,
      isViewRendered,
      disableDragAndDropUpload,
      preSearchText,
    });

    // Expose setSelectedRows via ref
    useEffect(() => {
      if (dataGrid.current) {
        dataGrid.current.setSelectedRows = (indexes: any) => setSelectedRows(indexes, dataGrid);
      }
    }, [dataGrid.current, filesViewMode, isViewRendered, selectedFilesInIconsMode]);

    // Restore pending selected rows after filesData updates (e.g. after refreshFiles)
    useEffect(() => {
      if (dataGrid.current?._pendingSelectedRows) {
        const pendingRows = dataGrid.current._pendingSelectedRows;
        dataGrid.current._pendingSelectedRows = null;
        dataGrid.current?.slickGrid?.setSelectedRows(pendingRows);
      }
    }, [filesData, dataGrid]);

    // Reset dataGrid when switching view modes
    useEffect(() => {
      if (filesViewMode == fileViewModes.LARGE_ICONS_VIEW) {
        dataGrid.current = {};
      }
      setIsViewRendered(false);
    }, [filesViewMode]);

    const updateToolBar = useMemo(
      () => [
        ...commonToolbar,
        {
          show: true,
          rightAllign: true,
          template: () => (
            <TextFieldComponent
              id="fileSearchBox"
              onChange={searchFileHandler}
              value={query}
              placeholder={`Search ${selectedFolder?.name ?? ""}`}
            />
          ),
        },
      ],
      [commonToolbar, query, selectedFolder],
    );
    // const searchFilesTemplate = () => {
    //   return (
    //     <div className="flex flex-1">
    // <TextFieldComponent
    //   id="fileSearchBox"
    //   onChange={searchFileHandler}
    //   value={query}
    //   placeholder={`Search ${selectedFolder?.name ?? ""}`}
    // />
    //     </div>
    //   );
    // };

    // const breacrumbTemplate = () => {
    //   return (
    //     <div className="flex gap-3 flex-3 overflow-auto ps-2 items-center">
    //       <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
    //         {breadCrumbData.map((item: any) => (
    //           <Link
    //             key={item?.id}
    //             underline="hover"
    //             sx={{
    //               color: "#192048",
    //             }}
    //             fontSize={"0.8125rem"}
    //             className="cursor-pointer"
    //             onClick={() => setSelectedFolder(item)}
    //           >
    //             {item?.name}
    //           </Link>
    //         ))}
    //       </Breadcrumbs>
    //     </div>
    //   );
    // };

    // const toolbar = [
    //   {
    //     id: "breadcrumb",
    //     template: breacrumbTemplate,
    //   },
    //   {
    //     id: "searchFiles",
    //     rightAllign: true,
    //     template: searchFilesTemplate,
    //   },
    // ];

    const gridOptions = {
      enableContextMenu: false,
      enableGridMenu: false,
      enableColumnPicker: false,
      showEmptyDataMessage: true,
      emptyDataMessage: "",
      enableAutoSizeColumns: true,
    };

    // const getToolBar = () => {
    //   return (
    //     <Box
    //       onContextMenu={onContextMenu}
    //       className="w-full justify-between gap-4 items-center flex min-h-12 h-12 pe-2 border-t border-button_light overflow-auto"
    //     >
    //       {toolbar.map((item) => (
    //         <React.Fragment key={item.id}>{item.template()}</React.Fragment>
    //       ))}
    //     </Box>
    //   );
    // };

    const onReactGridCreated = (reactGrid: any) => {
      handleGridCreated(reactGrid, dataGrid);

      const emptyDiv = reactGrid.slickGrid.getContainerNode().querySelector(".slick-empty-data-warning");
      if (emptyDiv) {
        emptyDiv.classList.add("h-full");
        const root = createRoot(emptyDiv);
        root.render(
          <div className="flex flex-col items-center justify-center">
            <IconComponent name="folder" className="mb-2" width="3rem" height="3rem" />
            <Text className="not-italic">{t("This folder is empty")}</Text>
          </div>,
        );
      }
    };

    const getDetailsGrid = () => {
      const props = disableDragAndDropUpload
        ? {}
        : {
            onDragEnter: onDragEnter,
            onDragOver: onDragOver,
            onDragLeave: onDragLeave,
            onDrop: handleDrop,
          };
      return (
        <Box id="fileManagerDetailsView" className={`w-full h-full`} {...props}>
          {isOver && (
            <div className="pointer-events-none absolute inset-0 z-20 flex items-center justify-center border-4 border-dashed border-blue-500 rounded-md">
              <span className="px-4 py-2 rounded-md bg-white/70 text-blue-600 font-semibold shadow-sm">
                <Text>{t("Drop files here")}</Text>
              </span>
            </div>
          )}
          <Box className={`w-full h-full transition ${isOver ? "opacity-30" : ""}`} onContextMenu={onContextMenu}>
            <SlickGrid1
              ref={dataGrid}
              disabledIds={disabledRows}
              disableContextMenu
              toolbarHeight={15}
              enableSelectAllCheckbox
              gridOptions={gridOptions}
              disableGridMargin
              onReactGridCreated={onReactGridCreated}
              onSelectedRowIdsChanged={() => selectionHandlerSlickGrid(dataGrid)}
              columnDefinitions={columnDefinitions}
              dataset={filesData}
              enableSearchBar={false}
              // Project ("Folders") mode: show this grid's fully-wired toolbar and portal it into the shared
              // slot above the tree + grid, fed the file-manager toolbar items. Otherwise keep it hidden.
              toolbar={toolbarContainer ? updateToolBar : undefined}
              toolbarClickHandler={commonToolbarClickHandler}
              disableToolbar={!toolbarContainer}
              toolbarContainer={toolbarContainer}
              disableOuterBorder={disableOuterBorder}
              showToolbarBorder
              propertiesPanel={true}
              propertiesDisabled={false}
              enableSortingOption
              enableFilteringOption
              enableGroupingOption
              enableColumnChooser
            />
          </Box>
        </Box>
      );
    };

    const renderMenuItems = (items = []) => {
      return items?.map((item: any) => {
        return (
          <MenuItem disabled={item.disabled} key={item.id} onClick={() => handleMenuClick(item, dataGrid)}>
            <div className="flex gap-4 text-sm items-center">
              {item.icon && <IconComponent name={item.icon} width="1.5rem" height="1.5rem" />}
              {item.name}
            </div>
          </MenuItem>
        );
      });
    };

    const getFilesIconsView = () => {
      setIsViewRendered(true);
      return (
        <Box
          id="fileManagerLargeIconsView"
          ref={dataGrid}
          onContextMenu={onContextMenu}
          className="p-5 border-t h-full border-button_light w-full overflow-auto"
        >
          <div className="flex flex-wrap gap-10 w-full overflow-auto">
            {filesData.map((file: any) => (
              <Box
                key={file.id}
                onDoubleClick={() => recordClick(file)}
                onContextMenu={(e) => contextMenuForIconsView(e, file)}
                className={`group flex relative flex-col p-2 h-max pt-3 rounded overflow-hidden cursor-pointer text-ellipsis whitespace-nowrap gap-1 w-20 ${selectedFilesInIconsMode.find((item: any) => item.id == file.id) ? "bg-card_selection_color" : "hover:bg-card_hover_color"} ${disabledRows.includes(file.id) || file.isRowDisabled ? "opacity-40 pointer-events-none" : ""}`}
              >
                <div
                  className={`absolute flex top-1 start-1 opacity-0 group-hover:opacity-100 transition-opacity ${selectedFilesInIconsMode.find((item: any) => item.id == file.id) ? "opacity-100" : ""}`}
                >
                  <CheckBoxComponent
                    onChange={(args) => checkIconBoxSelect(args, file)}
                    size="small"
                    checked={!!selectedFilesInIconsMode.find((item: any) => item.id == file.id)}
                    sx={{ padding: "0" }}
                  />
                </div>

                <div className="items-center justify-center flex">{getIconbasedOnResourceType(file, "h-10")}</div>

                <div className="overflow-hidden text-center text-ellipsis whitespace-nowrap">{file.name}</div>
              </Box>
            ))}
          </div>
        </Box>
      );
    };

    const getFilesAccordingToSelectedView = () => {
      if (filesViewMode == fileViewModes.DETAILED_VIEW) {
        return getDetailsGrid();
      } else if (filesViewMode == fileViewModes.LARGE_ICONS_VIEW) {
        return getFilesIconsView();
      }
    };

    const getFilesAndTools = () => (
      <div className="flex items-center flex-col h-full w-full">
        {/* {getToolBar()} */}
        {getFilesAccordingToSelectedView()}
      </div>
    );

    return (
      <div className="w-full h-full">
        {getFilesAndTools()}
        <Menu
          id="demo-positioned-menu"
          anchorReference="anchorPosition"
          anchorPosition={menuState.position}
          open={menuState.open}
          onClose={handleClose}
        >
          {renderMenuItems(menuState.options)}
        </Menu>
      </div>
    );
  },
);

Files.displayName = "Files";
export default Files;
